import services from '@/config/services'

export default class UtilityContoAcquistoService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getAll(){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/utility/fornitori/conti-acquisto`

    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async getFornitori(){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/utility/fornitori`

    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async getDescrizioni(id){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/utility/fornitori/${id}/descrizioni`

    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async create(id, conto, descrizioni){

    let result = {
      item: null,
      success: false,
    }

    const url = `${this.baseUrl}/utility/fornitori/conti-acquisto`

    const config = {
      data: {
        cod_fornitore: id,
        conto,
        descrizioni: descrizioni.map((el) => el.id)
      }
    }

    try {
      let res = await this.http.post(url, config)
    
      res = res.data

      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item: result.item,
        success: result.success,
      }
    }

  }

  async update(id, descrizioni){

    let result = {
      item: null,
      success: false,
    }

    const url = `${this.baseUrl}/utility/fornitori/conti-acquisto/${id}`

    const config = {
      data: {
        descrizioni: descrizioni.map((el) => el.id)
      }
    }

    try {
      let res = await this.http.put(url, config)
    
      res = res.data

      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item: result.item,
        success: result.success,
      }
    }

  }

  async delete(id){
    let success = false

    const url = `${this.baseUrl}/utility/fornitori/conti-acquisto/${id}`
    try {
      let res = await this.http.delete(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }
}
